<template>
  <!-- 弹框 -->
  <Modal
    v-model="editListModal"
    width="700"
    title="开票成功"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
  <Form
    ref="editListForm"
    label-position="right"
    :label-width="120"
    :rules="ruleValidate"
    :model="editListForm"
  >
    <FormItem label="发票编号"
      prop="invoice_no"
      label-for="invoice_no"
    >
      <Input
        placeholder="请输入发票编号"
        element-id="invoice_no"
        v-model="editListForm.invoice_no"
      ></Input>
    </FormItem>
    <FormItem label="物流编号"
      prop="logistics_no"
      label-for="logistics_no"
    >
      <Input
        placeholder="请输入物流编号"
        element-id="logistics_no"
        v-model="editListForm.logistics_no"
      ></Input>
    </FormItem>
    <FormItem label="开票凭证图片"
      label-for="img_url_list"
    >
    <UploadImg
      :defaultList="defaultImgList"
      @on-change="editListForm.img_url_list = $event">
    </UploadImg>
    </FormItem>
</Form>
</Modal>
</template>

<script>
import UploadImg from '@/components/UploadImg'

export default {
  components: {
    UploadImg
  },
  props: {
    ApplyId: {
      type: Number,
      required: true
    },
    editModal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      listLoading: false,
      loading: true,
      defaultImgList: [],
      editListModal: this.editModal,
      editListForm: {
        invoice_no: '',
        logistics_no: '',
        img_url_list: []
      },
      ruleValidate: {
        invoice_no: [
          { required: true, message: '请输入发票编号', trigger: 'blur' }
        ],
        logistics_no: [
          { required: true, message: '请输入物流编号', trigger: 'blur' }
        ]
        // img_urls: [
        //   { required: true, message: '最少提交一张开票凭证图片', trigger: 'blur' }
        // ]
      }
    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  methods: {
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          for (let obj in this.editListForm) {
            if (obj === 'img_url_list') {
              let arr = []
              this.editListForm[obj].forEach(val => {
                arr.push(val.url)
              })
              this.editListForm[obj] = arr
            }
          }
          let data = {
            id: this.ApplyId,
            ...this.editListForm
          }
          let url = '/invoice/handle'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              this.$Message.success('开票成功')
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.defaultImgList = []
      this.editListForm = {
        invoice_no: '',
        logistics_no: '',
        img_url_list: []
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/handle/isuseInvoiceHandle/editSuccess.vue